"use client";
import React, { useState, useEffect, useRef } from "react";
import { AdaptiveListProps, ListItem } from "./types";
import AdaptiveListItem from "./AdaptiveListItem";

interface AdaptiveListComponentProps extends AdaptiveListProps {
  onOpenModal: (
    header: string,
    text: string,
    modalLink?: { url: string; title: string } | string,
    contactButton?: string
  ) => void;
  openContactModal: () => void;
}

const AdaptiveList: React.FC<AdaptiveListComponentProps> = ({
  list,
  onOpenModal,
  openContactModal,
}) => {
  const [itemWidth, setItemWidth] = useState<number | "auto">("auto");
  const containerRef = useRef<HTMLUListElement>(null);

  const contactItem = list.find((item) => item.action_type === "contact");
  const filteredList = list.filter((item) => item.action_type !== "contact");

  useEffect(() => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const totalItems = filteredList.length;
      const minWidth = 150;
      const maxWidth = 300;
      const padding = 10 * (totalItems - 1);

      let calculatedWidth = (containerWidth - padding) / totalItems;

      if (calculatedWidth < minWidth) {
        calculatedWidth = minWidth;
      } else if (calculatedWidth > maxWidth) {
        calculatedWidth = maxWidth;
      }

      setItemWidth(calculatedWidth);
    }
  }, [filteredList]);

  const handleItemClick = (item: ListItem) => {
    if (item.action_type === "contact") {
      openContactModal();
    } else {
      onOpenModal(
        item.modal_header || "",
        item.modal_text || "",
        item.modal_link,
        item.contact_button
      );
    }
  };

  return (
    <div className="flex flex-col items-center w-full mt-2 space-y-6">
      <ul
        ref={containerRef}
        className="flex flex-wrap justify-center w-full gap-2 p-0 list-none"
      >
        {filteredList.map((item, index) => (
          <AdaptiveListItem
            key={index}
            item={item}
            itemWidth={itemWidth}
            onClick={() => handleItemClick(item)}
          />
        ))}
      </ul>

      {contactItem && (
        <ul className="flex justify-center w-full p-0 list-none">
          <AdaptiveListItem
            item={contactItem}
            itemWidth="auto"
            onClick={() => handleItemClick(contactItem)}
          />
        </ul>
      )}
    </div>
  );
};

export default AdaptiveList;
